<div class="call-top-alert">
  <qai-alert [kind]="'warning'" [title]="title">
    {{ message }}
  </qai-alert>
</div>